var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7983 2.16218C11.1888 1.77166 11.1888 1.1385 10.7983 0.747971C10.4078 0.357447 9.7746 0.357447 9.38408 0.747971L6.00027 4.13178L2.61647 0.747975C2.22595 0.35745 1.59278 0.35745 1.20226 0.747975C0.811732 1.1385 0.811732 1.77166 1.20226 2.16219L4.58606 5.54599L1.20226 8.92979C0.811732 9.32032 0.811732 9.95348 1.20226 10.344C1.59278 10.7345 2.22595 10.7345 2.61647 10.344L6.00027 6.9602L9.38408 10.344C9.7746 10.7345 10.4078 10.7345 10.7983 10.344C11.1888 9.95349 11.1888 9.32032 10.7983 8.9298L7.41449 5.54599L10.7983 2.16218Z",
    fill: "#404585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.74251a1c64fe170b0e2adaad7f7c59fc.svg";
export { ForwardRef as ReactComponent };